import {Animate, fadeIn, fadeOut} from '@lit-labs/motion'

interface AnimationOpts {
  fast: boolean
  animationCurve?: string
}

const ANIMATION_CURVES: {[key: string]: string} = {
  easeInOutCubic: 'cubic-bezier(0.65, 0, 0.35, 1)',
}

const animateHeightFrames = (animate: Animate) => {
  const {animatingProperties: props, frames, element} = animate

  if (frames === undefined || props === undefined) {
    return frames
  }

  const elementHeight =
    Number(props.height) > 0
      ? Number(props.height)
      : element.getBoundingClientRect().height

  const collapsed: Keyframe = {
    height: `1px`,
  }

  const expanded: Keyframe = {
    height: `${elementHeight}px`,
  }

  if (Number(props.height) > 0) {
    return [expanded, collapsed]
  }

  return [collapsed, expanded]
}

export function animateHeightContainer (opts?: AnimationOpts) {
  const duration = opts?.fast ? 300 : 400
  const easing = opts?.animationCurve
    ? ANIMATION_CURVES[opts.animationCurve]
    : ANIMATION_CURVES.easeInOutCubic
  return {
    keyframeOptions: {
      easing,
      duration,
    },
    properties: ['transform', 'height'],
    onFrames: animateHeightFrames,
    stabilizeOut: true,
  }
}

export function animateWidthContainer (opts?: AnimationOpts) {
  const duration = opts?.fast ? 300 : 400
  const easing = opts?.animationCurve
    ? ANIMATION_CURVES[opts.animationCurve]
    : ANIMATION_CURVES.easeInOutCubic

  return {
    keyframeOptions: {
      easing,
      duration,
    },
    properties: ['transform', 'width'],
    onFrames: animateWidthFrames,
    stabilizeOut: true,
  }
}

const animateWidthFrames = (animate: Animate) => {
  const {animatingProperties: props, frames, element} = animate

  if (frames === undefined || props === undefined) {
    return frames
  }

  const elementWidth =
    Number(props.width) > 0
      ? Number(props.width)
      : element.getBoundingClientRect().width

  const collapsed: Keyframe = {
    width: `1px`,
  }

  const expanded: Keyframe = {
    width: `${elementWidth}px`,
  }

  if (Number(props.width) > 0) {
    return [expanded, collapsed]
  }

  return [collapsed, expanded]
}

export function animateFadeInOut (opts?: AnimationOpts) {
  const duration = opts?.fast ? 300 : 400
  const easing = opts?.animationCurve
    ? ANIMATION_CURVES[opts.animationCurve]
    : ANIMATION_CURVES.easeInOutCubic

  return {
    keyframeOptions: {
      duration,
      easing,
      fill: 'both' as FillMode,
    },
    out: fadeOut,
    stabilizeOut: true,
    in: fadeIn,
  }
}
